document.addEventListener('DOMContentLoaded', function() {
  function alinharSlider() {
    const produtos = document.querySelectorAll('.ecom-collection__product-item.ecom-swiper-slide');

    if (!produtos.length) {
      console.warn('⛔ Nenhum produto encontrado no slider.');
      return;
    }

    produtos.forEach(produto => {
      const titulo = produto.querySelector('.ecom-collection__product-item-information-title');
      if (titulo) titulo.style.minHeight = 'unset';
    });

    let maxTitulo = 0;
    produtos.forEach(produto => {
      const titulo = produto.querySelector('.ecom-collection__product-item-information-title');
      if (titulo) {
        const altura = titulo.offsetHeight;
        if (altura > maxTitulo) maxTitulo = altura;
      }
    });

    produtos.forEach(produto => {
      const titulo = produto.querySelector('.ecom-collection__product-item-information-title');
      const preco = produto.querySelector('.ecom-collection__product-price');
      const botao = produto.querySelector('.ecom-collection__product-form__actions--add');

      produto.style.display = 'flex';
      produto.style.flexDirection = 'column';
      produto.style.height = '100%';

      if (titulo) titulo.style.minHeight = `${maxTitulo}px`;
      if (preco) preco.style.marginTop = 'auto';
      if (botao) botao.style.marginTop = '10px';
    });

    console.log('✅ Alinhamento aplicado ao slider');
  }

  const intervalo = setInterval(() => {
    const wrapper = document.querySelector('.ecom-swiper-wrapper');
    const produtos = document.querySelectorAll('.ecom-collection__product-item.ecom-swiper-slide');

    if (wrapper && produtos.length) {
      clearInterval(intervalo);
      alinharSlider();

      const observer = new MutationObserver(() => alinharSlider());
      observer.observe(wrapper, { childList: true, subtree: true });

      console.log('👁️ Observer ativado no slider');
    }
  }, 300);
});
